// External modules

// Internal modules
import * as constants from './constants';

const onAuthError = function onAuthErrorHandlerByForceThemToLogOut(error) {
  if (error.code && constants.AUTH_ERROR_CODES.includes(error.code)) {
    alert('Authentication error/expired, please log back in...');
    window.location.replace('/logout');
  }
};

export { onAuthError };
